import { Daycohost } from '@/modules/shared/shared/domain/constants/constants';

export function hasPrivilegesOf(role, privilege: number): boolean {
    try {
        return !!role.find(i => i.privilege.resource.id === privilege);
    } catch (e) {
        return false;
    }
}

export function hasPrivilegesOfAction(role, privilegeResource: number, privilegeAction: number) {
    try {
        return !!role.find(
            i =>
                i.privilege.resource.id == privilegeResource &&
                i.privilege.action.id == privilegeAction,
        );
    } catch (e) {
        return false;
    }
}

export function isCustomer(contact): boolean {
    try {
        return contact.customer.id !== Daycohost.id;
    } catch (e) {
        return false;
    }
}

export function isEmployee(contact): boolean {
    try {
        return contact.customer.id === Daycohost.id;
    } catch (e) {
        return false;
    }
}
